import styled from "styled-components";

export const InfoBoxContainer = styled.div`
    display: block;
    background: rgb(242, 245, 248);
    padding: 16px;
    width: fit-content;
`;
